import { Component } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { DialogServicePracticeComponent } from '@pages/tables/service-practices/dialog-service-practice/dialog-service-practice.component';
import { ServicePracticesModel } from '@/models/tables/service-practices.model';

@Component({
  selector: 'app-button-new-service-practice',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonNewServicePracticeComponent extends ButtonComponent {
  private dialogOpened: MatDialogRef<any>;
  faIcon = faPenToSquare;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = false;
    this.additionalClass = 'ml-2';
    this.content = 'Nuovo Servizio pratica';
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogServicePracticeComponent, {
      data: new ServicePracticesModel(),
    });

    Registry.getInstance().set('DialogServicePracticeComponentNew', this.dialogOpened);
  }
}
